module.exports = __webpack_public_path__ + "img/xlkc_bhkc.0923393f.png";